import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Button } from 'reactstrap';

const BreadCrumb = ({ title, links, hidden = false, controls = null, icon }) => {
	document.title = 'SPED - ' + title;

	if (hidden) return null;

	return (
		<React.Fragment>
			<Row>
				<Col xs={12}>
					<div className='page-title-box d-sm-flex  justify-content-between py-2'>
						{/* <h4 className='mb-sm-0 d-flex align-items-center gap-2'>
							{controls?.prev}
							<span>{title}</span>
							{controls?.next}
						</h4> */}

						{links && links.length > 0 && (
							<div className='page-title-right'>
								<ol className='breadcrumb m-0 d-flex align-items-center'>
									{links.map((link, index) => (
										<li className='breadcrumb-item d-flex align-items-center' key={index}>
											{link.to ? (
												<Link 
													to={link.to}
													style={{
														cursor: 'pointer',
														color: 'var(--vz-primary)',
													}}
													className='d-flex align-items-center gap-1'
												>
													{link.icon && <i className={link.icon}></i>}
													<span>{link.label}</span>
												</Link>
											) : (
												<span className='d-flex align-items-center gap-1'>
													{link.icon && <i className={link.icon}></i>}
													<span>{link.label}</span>
												</span>
											)}
										</li>
									))}
									<li className='breadcrumb-item active d-flex align-items-center' style={{color: 'var(--vz-secondary)'}}>
										<span className='d-flex align-items-center gap-1'>
											{icon && <i className={icon}></i>}
											<span>{title}</span>
										</span>
									</li>
								</ol>
							</div>
						)}
					</div>
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default BreadCrumb;
